import Base from "./Base";
import axios from "./axios_c";
import Bom from "@system/config/bom";
import ResponseMaker from "./BOMAPICall/BomDetail/responseMaker";
import SearchMatchResponseMaker from "./BOMAPICall/BomDetail/searchMatchResponseMaker";
import store from "../storeWire";
import BOMRepository from "../repository/BOMRepository";
import ProductDetailAPICall from "./ProductDetailAPICall";
import System from "../helper/system";
import Helper from "../support/Helper";
import liveAuth from "../helper/liveAuth";
import { __remove, __set } from "../store/axios_indicator";
import { isArray } from "underscore";
import { set_to_master_data_only_products_list } from "src/store/slice/model/ProductListing";
import storeInUse from "../storeWire";
import Auth from "@system/config/auth";
import Api from "../service/APIHandler";
const API = new Api({});
class BOMAPICall extends Base {
    fetchBOMList = async (params = {}) => {
        if (!liveAuth.check()) {
            return {};
        }
        let res = {};
        await this.axiosCall(Bom.BOM_LISTING, {
            ...params,
            bomName: '',
            "top": -1,
            "skip": 0
        }).then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    createBOM = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.CREATE_BOM, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    assignBOMToProject = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.ASSIGN_BOM_TO_PROJECT, params, 'PUT').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    editBOM = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.EDIT_BOM, params).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    setBOMIsRematchFlag = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.BOM_SET_IS_REMATCH_FLAG_IN_BOM_DETAIL, params, 'PUT').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    addPartToBOM = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.ADD_PART_TO_BOM, params, 'POST', true, false).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    getBomDetailByBomID = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.BOM_DETAIL_BY_BOM_ID, {
            ...params
        }, 'get').then((resHer) => {
            res = resHer.data.data;
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };
    deleteBOMByBomID = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.BOM_DELETE_BY_BOM_ID, {
            ...params
        }, 'DELETE').then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    copyBOMByBomID = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.BOM_COPY_BY_BOM_ID, params, 'PUT').then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    getBomHealthByBomID = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.BOM_HEALTH_BY_BOM_ID, {
            ...params
        }, 'get', false, false, true).then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    getBomDetailByBomIDWithType = async (params = {}) => {
        let res = {};
        if (params.top === undefined) {
            params.top = 10;
        }
        if (params.top !== undefined) {
            params.top = parseInt(params.top);
        }
        if (params.top > 0 && window.bom_skip_calulated !== undefined && window.bom_skip_calulated === 'yes') {
            params.skip = params.top - 10;
            window.bom_skip_calulated = 'yes';
        } else {
            let skipData = params.skip
            params.skip = params.skip === 0 ? params.skip : params.top > 20 ? params.top - 10 : 0;
            params.top = skipData === 0 ? params.top + 1 : params.top > 20 ? 10 : 20
        }
        if (!params.sortColumn) { // 10889
            params = {
                ...params,
                "sortColumn": "sequence_number",
                "sortOrder": "asc"
            };
        }

        params.isReRunPartMatch = true;

        await this.axiosCall(Bom.BOM_DETAIL_BY_BOM_ID_WITH_TYPE, {
            ...params
        }, 'POST').then((resHer) => {
            res = resHer.data.data;

        }).catch(e => {
            setTimeout(() => {
                window.location.href = Bom.getBomRouteURL();
            }, 2000)
        });
        let result = await new ResponseMaker(res)
        result = await result.process(params)
        return result.run().get()
    };
    downloadBomTemplate = async (params = false) => {
        let res = {};
        axios({
            url: Bom.DOWNLOAD_BOM_TEMPLATE,
            method: 'POST',
            responseType: 'blob',
            headers: Helper.getCommonHeader('POST')
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bomTemplate.xlsx');
            document.body.appendChild(link);
            link.click();
        });
        return res;
    }

    // checkoutfarnell = (params = false) => {
    //     let res = {};
    //     axios({
    //         url: "https://uk.farnell.com/PFConfigurator?type=AVNET&langId=44",
    //         method: 'POST',
    //         headers: { 'Content-Type': ' application/x-www-form-urlencoded' },
    //         data: {
    //             "ITEM": [
    //                 {
    //                     "SUPPLIER_ID_DUNS": "Avnet",
    //                     "MANUFACTURER_PID": "HDMR-19-01-S-SM",
    //                     "QUANTITY": "2",

    //                 },
    //                 {
    //                     "SUPPLIER_ID_DUNS": "Avnet",
    //                     "MANUFACTURER_PID": "XRCGB25M000F3M00R0",
    //                     "QUANTITY": "4",

    //                 }
    //             ]
    //         }
    //     }).then((response) => {
    //         console.log(response)
    //     });
    //     return res;
    // }

    fetchProductCategoryList = async () => {
        return await new ProductDetailAPICall().getProductCategory();
    };
    attachBOMAlternativeToBOMDetailAPICall = async (res_data_Exact_records) => {
        let itemNumbersArray = [];
        let itemNumbersArrayResponseObject = {};
        Object.entries(res_data_Exact_records).map((v) => {
            if (v[1].bom_alternative_object === undefined && v[1].itemNumber) {
                itemNumbersArray.push(v[1].itemNumber)
            }
        });
        if (itemNumbersArray.length === 0) {
            return res_data_Exact_records;
        }
        const config = {
            method: 'post',
            url: Bom.BOM_DETAIL_ALTERNATIVE_COUNT_CALL,
            headers: Helper.getCommonHeader('POST'),
            data: {
                speedBoat: System.auth('speedBoat'),
                itemNumbers: itemNumbersArray,
                "productResponseTypes": "CountOnly",
                "orderby": "",
                "top": 0,
                "skip": 0
            }
        };
        try {
            await axios(config)
                .then(function (response) {
                    if (response?.data?.Data &&
                        isArray(response.data.Data) &&
                        response.data.Data.length > 0
                    ) {
                        response.data.Data.map((v) => {
                            itemNumbersArrayResponseObject[v.ItemNumber] = v;
                        })
                    }
                });
        } catch (e) {
            return res_data_Exact_records;
        }
        Object.entries(res_data_Exact_records).map((v) => {
            if (itemNumbersArrayResponseObject[v[1].itemNumber] !== undefined) {
                res_data_Exact_records[v[0]].bom_alternative_object = itemNumbersArrayResponseObject[v[1].itemNumber];
            }
        });
        return res_data_Exact_records;
    };
    createPartList = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.CREATE_PART_LIST, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    bomUploadFile = async (file, source) => {
        const formData = new FormData()
        formData.append("file", file)
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
        let size_in_mb = Helper.bytesToMB(file.size);
        if (size_in_mb > 20) {
            System.alert('Your file may have been altered to meet the file requirements for BOM.', 'warning', 'bomUpload')
            return {};
        }
        //xls, xlsx,csv, tab, txt.
        let validatedStatus = false;
        if (extension === 'xls') {
            validatedStatus = true;
        }
        if (extension === 'xlsx') {
            validatedStatus = true;
        }
        if (extension === 'csv') {
            validatedStatus = true;
        }
        if (extension === 'tab') {
            validatedStatus = true;
        }
        if (extension === 'txt') {
            validatedStatus = true;
        }
        let res = {};
        if (validatedStatus) {
            System.clearAllAlert();
            let interval = false;
            let api_failed = false;
            const config = {
                method: 'post',
                url: Bom.BOM_UPLOAD_FILE,
                headers: Helper.getCommonHeader('POST', 'multipart/form-data'),
                data: formData,
                params: { source },
            };
            await axios(config)
                .then(function (response) {
                    res = response.data;
                }).catch((e) => {
                    if (e?.response?.data?.Message !== undefined) {
                        System.alert(e.response.data.Message, 'danger', 'bomUpload')
                    }
                });
        } else {
            System.alert('Invalid file format. Please upload a valid file', 'danger', 'bomUpload')
        }
        return res;
    }

    bomUploadProgress = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.BOM_UPLOAD_FILE_PROGRESS, {
            ...params
        }, 'get').then((resHer) => {
            res = resHer.data.data;
        }).catch(e => {
            console.log(e)
        });
        return res;
    };

    updateQuantityByBomDetailID = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.UPDATE_BOM_DETAIL_QUANTITY_BY_BOM_DETAIL_ID, {
            ...params
        }, 'PUT').then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    updateCustomerPartNumberByBomDetailID = async (params = {}) => {
        if (params.customerPartNumber !== undefined && params.customerPartNumber === false) {
            params.customerPartNumber = '';
        }
        if (params.customerPartNumber !== undefined && params.customerPartNumber === 'false') {
            params.customerPartNumber = '';
        }
        let res = {};
        await this.axiosCall(Bom.UPDATE_BOM_DETAIL_CUSTOMER_PART_NUMBER_BY_BOM_DETAIL_ID, {
            ...params
        }, 'PUT').then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };
    swapPartNumber = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.SWAP_PART_NUMBER, params, 'PUT', false, false, true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    bomDownloadFile = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.BOM_DOWNLOAD_FILE, params, 'post', true, true).then(async (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'BOM.' + params.fileType);
            document.body.appendChild(link);
            link.click();
            let s = store.getState().entities.model_BOM_BOMDownloadPopup;
            s = { ...s }
            if (s.save_preference !== undefined &&
                s.save_preference === 'yes'
            ) {
                delete s.save_preference;
                await new BOMRepository().saveDownloadFilePreference(s);
            }
        });
        return res;
    };
    bomEmailFile = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.BOM_EMAIL_FILE, params).then(async (response) => {
            res = response.data;
            let s = store.getState().entities.model_BOM_BOMDownloadPopup;
            s = { ...s };
            if (s.save_preference !== undefined &&
                s.save_preference === 'yes'
            ) {
                delete s.save_preference;
                await new BOMRepository().saveDownloadFilePreference(s);
            }
        });
        return res;
    };
    saveDownloadFilePreference = async (params = {}) => {
        let res = {};
        params.preferenceType = params?.prefType ? params.prefType : 'Download_Bom_Columns';
        await this.axiosCall(Bom.SAVE_DOWNLOAD_BOM_PREFERENCE, params, "POST", true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    fetchDownloadFilePreference = async (params = {}) => {
        let res;
        params.preferenceType = params?.prefType ? params.prefType : 'Download_Bom_Columns';
        await this.axiosCall(Bom.FETCH_DOWNLOAD_BOM_PREFERENCE, params).then((resHer) => {
            if (resHer.data.data) {
                res = JSON.parse(resHer.data.data);
            }
        }).catch((err) => {
            if (err.response.data.Message === "No records found.") {
                res = { selected_fields: {}, export_type: "csv" }
            }
        });
        return res;
    };
    removePartNumber = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.REMOVE_PART_NUMBER, params, 'put').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false, skipMergeData = false) => {
        if (data === 'NA') {
            data = {};
        } else if (!skipMergeData) {
            data = await this.mergeDataWithBase(data);
        }
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };

        // Set Response Type as Blob 
        if (isBlob) {
            config.responseType = 'blob';
        }

        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        if (data.LifeCycleRisk !== undefined) {
            if (!data.LifeCycleRisk || data.LifeCycleRisk === '' || data.LifeCycleRisk === null) {
                data.LifeCycleRisk = '';
            }
        }
        if (data.LifeCycleRisk === undefined) {
            data.LifeCycleRisk = '';
        }
        if (data.ERPPartNumber !== undefined) {
            data.erpPartNumber = data.ERPPartNumber;
        }
        if (data.partNumber !== undefined &&
            data.partNumber
        ) {
            if (data.erpPartNumber === undefined) {
                data.erpPartNumber = data.partNumber;
            }
            if (data.erpPartNumber !== undefined && !data.erpPartNumber) {
                data.erpPartNumber = data.partNumber;
            }
        }
        if (data.ManufacturerPartNumber !== undefined && data.ERPMFRPartNumber === undefined) {
            data.partNumber = data.ManufacturerPartNumber;
        }
        if (data.ERPMFRPartNumber) {
            data.partNumber = data.ERPMFRPartNumber;
        }
        if (data.ItemNumber !== undefined) {
            data.itemNumber = data.ItemNumber;
        }

        //Removing if its still false
        if (data.ManufacturerPartNumber === false) {
            data.ManufacturerPartNumber = '';
        }
        if (data.partNumber === false) {
            data.partNumber = '';
        }
        if (data.erpPartNumber === false) {
            data.erpPartNumber = '';
        }
        if (data.itemNumber === false) {
            data.itemNumber = '';
        }
        if (data.CUSTOMER_PART_NUMBER !== undefined) {
            data.customerPartNumber = data.CUSTOMER_PART_NUMBER;
        }
        if (data.customerPartNumber !== undefined && data.customerPartNumber === false) {
            data.customerPartNumber = '';
        }
        if (data.customerPartNumber !== undefined && data.customerPartNumber === 'false') {
            data.customerPartNumber = '';
        }
        return {
            ...data
        };
    };

    getMultipleMatchProductSearch = async (params = {}) => {
        let res = {};
        let param = { ...params }
        param.top = 10
        param.speedBoat = await Auth.getAuthSBoat();
        __set('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
        await this.axiosCall(Bom.BOM_MULTIPLE_MATCH_PRODUCT_SEARCH, {
            ...param
        }, 'get').then(async (resHer) => {
            res = resHer.data.Data;
            let res_made = new SearchMatchResponseMaker(res).process().run().get();
            await storeInUse.dispatch(await set_to_master_data_only_products_list(res_made));
            if (res_made && isArray(res_made) && res_made.length > 0) {
                res['Products'] = res_made;
            }
            __remove('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
        }).catch(() => {
            __remove('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
        });
        return res;
    };

    updateDisplayOrder = async (params = {}) => {
        let res = {};
        await this.axiosCall(Bom.UPDATE_DISPLAY_ORDER, {
            ...params,
        }, 'PUT').then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    };

    getFarnellBomList = async (params) => {
        let res = {};
       
        const param = {}
        param.params = {"top": 20, "skip": 0, bomId: params}
        await API.get(Bom.BOM_Farnell_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data;
            }else{
                __remove('BOM_FARNELL_LIST_API_CALL');
            }
        });
        return res; 
    };

}

export default BOMAPICall;